import { _t } from "@cruisen/i18n"
import { callFirebaseFunction } from "../callFirebaseFunction"
import {
  ProfileRequestType,
  DeleteCruiseLineLoyaltyMemberInput,
  UpsertCruiseLineLoyaltyMemberOutput,
  UpsertCruiseLineLoyaltyMemberInput,
  TripID,
  SaveProfileInput,
  RevealPassportNumberInput,
  RevealPassportNumberOutput,
} from "@cruisen/contract"
import { callFirebaseHttpFunction } from "../callFirebaseHttpFunction"

export const fetchProfiles = async () => {
  const response = await callFirebaseFunction({
    name: "getProfiles",
    payload: {
      type: ProfileRequestType.OwnProfiles,
    },
  })
  if (response.error) throw new Error(response.message)
  return response.data.result.profiles.sort((a) => (a.isPrimaryProfile ? -1 : 1))
}

export const fetchAllTripUsersProfiles = async (tripId: TripID) => {
  const response = await callFirebaseFunction({
    name: "getProfiles",
    payload: {
      type: ProfileRequestType.AllTripUsersProfiles,
      tripId,
    },
  })
  if (response.error) {
    console.error("Error fetching all trip users profiles:", response)
    return []
  }
  return response.data.result.profiles
}

export const upsertCruiseLineLoyaltyMember = async (
  payload: UpsertCruiseLineLoyaltyMemberInput,
): Promise<UpsertCruiseLineLoyaltyMemberOutput> => {
  const response = await callFirebaseFunction({
    name: "userProfileAction",
    payload: {
      action: "upsertCruiseLineLoyaltyMember",
      ...payload,
    },
  })
  if (response.error) {
    alert(`${_t("errors.cruiseLineLoyaltyMember")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }
  return response.data?.result as UpsertCruiseLineLoyaltyMemberOutput
}

export const deleteCruiseLineLoyaltyMember = async (
  payload: DeleteCruiseLineLoyaltyMemberInput,
) => {
  if (!payload.cruiseLineLoyaltyMemberId) {
    alert(`${_t("errors.cruiseLineLoyaltyMember")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }
  const response = await callFirebaseFunction({
    name: "userProfileAction",
    payload: {
      action: "deleteCruiseLineLoyaltyMember",
      ...payload,
    },
  })
  if (response.error) {
    alert(`${_t("errors.cruiseLineLoyaltyMember")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }
  return response
}

export const saveProfile = async (payload: SaveProfileInput) => {
  const response = await callFirebaseHttpFunction({
    name: "saveProfile",
    payload,
  })
  if (response.error) {
    alert(`${_t("errors.profile")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }
  return response.data?.result?.profile
}

export const revealPassportNumber = async (
  payload: RevealPassportNumberInput,
): Promise<RevealPassportNumberOutput> => {
  const response = await callFirebaseHttpFunction({
    name: "revealPassportNumber",
    payload,
  })
  if (response.error) {
    alert(`${_t("errors.passportNumber")} ${_t("errors.tryAgainLater")}`)
    return undefined
  }
  return response.data
}
